import clsx from "clsx";
import { ArrowUpRightIcon, BriefcaseBusinessIcon } from "lucide-react";
import { Link, useNavigate } from "react-router";

import { Button } from "@/components/ui/button";

import { dates } from "@/lib/dates";
import { jobsStore } from "@/stores";
import { JobStatus } from "@/types";

export const DashboardActiveJobs = ({ className }: { className?: string }) => {
  const jobs = jobsStore((state) => state.jobs);
  const activeJobs = jobs.filter(({ job }) => job.status === JobStatus.ACTIVE);
  const navigate = useNavigate();

  return (
    <div className={clsx("border-200 rounded-lg border", className)}>
      <div className="flex w-full justify-between border-b border-slate-200 p-6 pb-4">
        <div className="flex flex-col gap-[6px]">
          <div className="flex items-center gap-2">
            <BriefcaseBusinessIcon className="h-5 w-5 text-slate-900" />
            <p className="text-xl font-semibold text-slate-900">Active Jobs</p>
          </div>
          <p className="text-sm text-slate-500">
            Jobs that are currently active
          </p>
        </div>
        <Button className="rounded-full" variant="outline" asChild>
          <Link to="jobs">
            View All <ArrowUpRightIcon className="h-4 w-4" />
          </Link>
        </Button>
      </div>
      {/* TODO: Way to not need to keep them in sync. */}
      {/* IMPORTANT: This max height needs to be kept in sync with `<DashboardPipelineActivity>` */}
      <div className="max-h-[444px] overflow-y-auto">
        {activeJobs.map(({ job }, index) => {
          return (
            <div
              className={clsx(
                "flex cursor-pointer justify-between px-6 py-4 hover:bg-slate-100",
                index > 0 && "border-t border-slate-200",
              )}
              key={job.id}
              onClick={() => {
                void navigate(`jobs/${job.id}`);
              }}
            >
              <div className="flex flex-col gap-1">
                <p className="truncate font-medium text-slate-900">
                  {job.title}
                </p>
                <p className="text-sm text-slate-500">
                  {job.city}, {job.state} • Posted{" "}
                  {dates.timeAgoForJob(job.createdAt)}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
